export default __webpack_public_path__ + "static/illustration-action-four.url-f203b05990565ca5d5365f5990631bf6.svg";